import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

import {
  BaseComponent,
  BaseEditFormModalComponent,
  ProductService,
  Supplier,
  SupplierReferenceService,
  SupplierService,
  TmsFormlyService,
} from 'tms-lib';
import { SupplierProductService } from 'tms-web-shared';

@Component({
  selector: 'app-product-suppliers-modal',
  templateUrl: './product-suppliers-modal.component.html',
  styleUrl: './product-suppliers-modal.component.scss',
})
export class ProductSuppliersModalComponent extends BaseComponent implements OnInit {
  @ViewChild(BaseEditFormModalComponent) form: BaseEditFormModalComponent;
  @Input() id: string;
  @Input() productId: string;

  fields: FormlyFieldConfig[];

  constructor(
    public supplierProductService: SupplierProductService,
    private productService: ProductService,
    private supplierService: SupplierService,
    private supplierReferenceService: SupplierReferenceService,
    private formlyService: TmsFormlyService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.getFields();
  }

  private getFields() {
    this.fields = [
      ...this.formlyService.supplierSearch(
        'supplierSearch',
        'supplierKey',
        undefined,
        (model: Supplier) => this.changeSupplier(model),
        () => this.clearSupplier(),
      ),
      this.formlyService.text('supplierKey', $localize`Supplier Account`, undefined, {
        readonly: true,
        required: true,
      }),
      this.formlyService.text('supplierName', $localize`Supplier`, undefined, { readonly: true, required: true }),
      this.formlyService.checkbox('default', $localize`Default`, undefined, { required: true }),
      this.formlyService.text('partNo', $localize`Part Number`),
      this.formlyService.number('stdPrice', $localize`Price`, undefined, { required: true }, undefined, {
        'props.append': (field: FormlyFieldConfig) => field.model?.currencyCode,
      }),
      this.formlyService.number('stdCutPrice', $localize`Cut Price`, undefined, undefined, undefined, {
        'props.append': (field: FormlyFieldConfig) => field.model?.currencyCode,
      }),
      this.formlyService.number('minimumOrderQty', $localize`Minimum Order Quantity`),
    ];
  }

  saved() {
    this.productService.refreshDetails.next();
  }

  private changeSupplier(supplier: Supplier) {
    this.form.updateModel({
      supplierId: supplier.id,
      supplierKey: supplier.key,
      supplierName: supplier.name,
      currencyCode: supplier.currencyCode,
    });
  }

  private clearSupplier() {
    this.form.updateModel({
      supplierId: undefined,
      supplierKey: undefined,
      supplierName: undefined,
      supplierAddressMultiLine: undefined,
      currencyCode: undefined,
    });
  }
}
